<template>
    <div class="flex flex-col items-center pt-8 pb-12 space-y-5" :class="headerClasses" style="background-repeat: no-repeat; background-size: cover;" 
      :style="[
        masked == true ? { backgroundImage: 'url(' + require('@/assets/images/overlays/maskOverlay.png') + ')' } : '',
        bgColour ? { backgroundColor: bgColour } : (gradientColour ? { backgroundImage: `linear-gradient(${gradientColour})` } : '' )
      ]"
    >
        <img :src="logoUrl(type)" alt="Logo of Lifepass." class="pb-2">
        <hr class="w-full h-px opacity-20" :class="seperatorClasses ? seperatorClasses : 'bg-white' ">
        <div class="search filtering px-6 w-full" v-if="toggledSearchState">
            <div class="rounded border bg-white border-gray-200 text-lg w-full flex relative items-center px-3 py-3">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4"><path d="M18.375 18.375L14.4497 14.4428M16.625 9.1875C16.625 11.16 15.8414 13.0518 14.4466 14.4466C13.0518 15.8414 11.16 16.625 9.1875 16.625C7.21495 16.625 5.3232 15.8414 3.92839 14.4466C2.53359 13.0518 1.75 11.16 1.75 9.1875C1.75 7.21495 2.53359 5.3232 3.92839 3.92839C5.3232 2.53359 7.21495 1.75 9.1875 1.75C11.16 1.75 13.0518 2.53359 14.4466 3.92839C15.8414 5.3232 16.625 7.21495 16.625 9.1875V9.1875Z" stroke="#223672" stroke-width="1.75" stroke-linecap="round"/></svg>
                <input type="text" id="search" class="absolute left w-full pl-8 focus:outline-none bg-transparent text-base" :placeholder="$t('search')" v-model="searchFilter" @keyup="searchFiltering">
            </div>
        </div>
        <div class="text-center space-y-2.5 px-6" v-if="title" :class="textClasses ? textClasses : 'text-primary' ">
            <h1 class="text-lg">{{ title }}</h1>
            <p class="text-base leading-5 max-w-xs px-8" v-if="text">{{ text }}</p>
        </div>
    </div>
</template>

<script>
export default {
  name: "Header",
  props: [
    'headerClasses', 'title', 'text', 'type', 'textClasses',
    'masked', 'bgColour', 'gradientColour', 'seperatorClasses',
  ],
  data() {
    return {
        logoLight: false,
        searchFilter: null,
    };
  },
  computed: {
    toggledSearchState() {
      return this.$store.state.searchStatus;
    },
  },
  watch: {
      toggledSearchState(newValue) {
          if(newValue == false) {
            this.$emit('filteringPasses', null);
          }
      }
  },
  mounted() {
    
  },
  methods: {
    searchFiltering() {
      if(this.searchFilter.length > 2) {
        this.$emit('filteringPasses', this.searchFilter);
      }
    },
    logoUrl(type) {
        if(type == 'light') {
            return require('@/assets/images/logos/LP_White.svg');
        } else {
            return require('@/assets/images/logos/LP_Full_Main.svg');
        }
    }
  }
};
</script>

<style>
</style>